import { AddressType } from '../constants/address-type.js';
/** Address types an event venue can default from, most preferred first. */
export const VENUE_ADDRESS_TYPE_IDS = [
    AddressType.SHIPPING,
    AddressType.MAIN_OFFICE,
];
//# sourceMappingURL=venue-address-type-ids.js.map